import React from "react";
// import specific_location_img from "../../images/hyderabad.jpg";
import { Link } from "react-router-dom";
import ChatButton from "../../components/ChatButton";
import { Helmet } from "react-helmet";

const Ghaziabad = () => {
  return (
    <>
    <Helmet>
      <title>Instant personal loan in ghaziabad | CreduMoney</title>
      <meta name="title" content="Instant personal loan in ghaziabad | CreduMoney"/>

    </Helmet>
      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper ghaziabad_banner">
          <div className="content_page_banner_wrapper_overlay">
            <h2>Location - Ghaziababad</h2>
          </div>
        </div>

        <div className="text_content_wrapper">
          <div className="text_content">
            {/* <div className="content_banner">
                <img src={specific_location_img} alt="" />
              </div> */}
            {/* <h3>Get an Instant Personal Loan in Hyderabad</h3> */}
            <h1 className="page_title mt30 mb20">Instant Personal Loans from Surya Personal Loan Company in Ghaziabad</h1>

            <p>Located on the eastern edge of Delhi, Ghaziabad is an essential part of the National Capital Region (NCR). Due to its well-developed infrastructure and seamless connectivity with neighbouring cities, such as Gurugram, Faridabad, Delhi, Noida, and Greater Noida, it’s a highly desirable city for those working in the corporate sector.</p>

            <p>Secondly, this city is connected to major highways like NH-24, NH-58, and the Eastern Peripheral Highway, making commuting easy and hassle-free. When it comes to comfortable residing, this amazing city has all, including the ISKCON temple, Shipra Mall, Swarna Jayanti Park, Drizzling Land Water & Amusement Park, Indirapuram Habitat Centre, etc.</p>
            <p>And, when it comes to financial support, CreduMoney offers Instant Personal Loan in Ghaziabad to help you effectively if you need funds for any unexpected, planned or emergency situations. Keep your PAN, Aadhar and Bank Statement handy, apply for a loan up to 1 LAKH and get the funds credited to your bank account in just 5 minutes. Scroll down to learn more about how to apply for a quick personal loan in Ghaziabad from CreduMoney.</p>

            <h3>Why CreduMoney is the Smartest Choice for Instant Personal Loans in Ghaziabad</h3>

            <p>CreduMoney’s personal loan service in Ghaziabad​ comes with a series of benefits so that you don’t feel the burden of repaying the loan amount. Let’s have a quick look at them one by one:</p>

            <ul>
              <li>Loan Approval and Disbursal in 10 Minutes</li>
              <li>100% Digital Process, right from approval to disbursal</li>
              <li>Paperless Application</li>
              <li>Minimal Documents required</li>
              <li>Collateral-free personal loans</li>
              <li>No Hidden Charges</li>
              <li>Apply from the comfort of your stay</li>
              <li>On-time reminders before the repayment date</li>
            </ul>

            <h3>How to Secure an Instant Personal Loan in Ghaziabad from CreduMoney?</h3>

            <p>The procedure to apply for a personal loan for salaried in Ghaziabad from CreduMoney is quite easy and hassle-free. Let’s have a look at the steps mentioned below.</p>
            <ul className="content_list">
              <li>
                Step 1: Visit our website or download the official CreduMoney app from the App/Play Store. Next, register your mobile number as a new user by entering the OPT.
              </li>
              <li>
                Step 2: The next step is to fill out the application form by entering your personal, residential, employment, and income details. Make sure that all the information you have entered is accurate.
              </li>
              <li>
                Step 3: Further, upload the required documents, such as identity proof, address proof, and income proof.
              </li>
              <li>
                Step 4: After you submit your loan application, our team carefully reviews your eligibility by evaluating every detail. If you fit our eligibility criteria, your loan application is instantly approved, and the amount is disbursed directly into your bank account. 
               </li>
              
            </ul>
            <div className="button_container flex justify-center mt30">
              <Link to="/apply-now">Apply Now</Link>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default Ghaziabad;
